export default __webpack_public_path__ + "static/media/yarden_truck_right_side.540f4895.jpg";